import React from "react";

interface UpdateAlertCard {
  updateInfo: {
    version: number;
    is_force: 0 | 1;
  };
  visible?: boolean;
  hide?: () => void;
}

const UpdateAlert: React.FC<UpdateAlertCard> = () => {
  return <></>;
};

export default UpdateAlert;
